import { selector } from 'recoil';
import UseHttpRequest from '../../components/api/HttpRequest';

const InventorySelector = selector({
  key: 'inventorySelector',
  get: async () => {
    try {
      const httpRequest = UseHttpRequest();

      const { items } = await httpRequest.send('/inventory/me/counts');

      // eslint-disable-next-line no-console
      console.log('invntory result', items);
      return items;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('unable to fetch inventroy');
      return [];
    }
  },
});

export default InventorySelector;
